export const TAX_SLABS = {
  THRESHOLD: 7500,
  LOW_RATE: 5,
  HIGH_RATE: 18,
};

export const EMPTY_LINE_ITEM = {
  description: "Extra Service",
  qty: 1,
  inclusiveRate: 0,
  inclusiveAmount: 0,
  base: 0,
  sgst: 0,
  cgst: 0,
  taxRate: 0,
};